import { render, staticRenderFns } from "./CabineteStudio.vue?vue&type=template&id=dcf2ed02&scoped=true&"
import script from "./CabineteStudio.vue?vue&type=script&lang=js&"
export * from "./CabineteStudio.vue?vue&type=script&lang=js&"
import style0 from "./CabineteStudio.vue?vue&type=style&index=0&id=dcf2ed02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf2ed02",
  null
  
)

export default component.exports